/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Rank_Floor_NationalInputs */



/**
* | output |
* | --- |
* | "National championships and above" |
*
* @param {Tournaments_Rank_Floor_NationalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_rank_floor_national = /** @type {((inputs?: Tournaments_Rank_Floor_NationalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Rank_Floor_NationalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Championnats nationaux et au-dessus")
	if (locale === "es") return /** @type {LocalizedString} */ ("Campeonatos nacionales y superiores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Campeonatos nacionais e acima")
	if (locale === "it") return /** @type {LocalizedString} */ ("Campionati nazionali e superiori")
	return /** @type {LocalizedString} */ ("National championships and above")
});